module.exports = __webpack_public_path__ + "img/led.289c625d.jpeg";